import { createContext, useContext, useRef } from 'react';

type Direction = 'left' | 'right';

type TabTransitionContextType = {
  setDirection: (d: Direction) => void;
  consumeDirection: () => Direction | null;
};

const TabTransitionContext = createContext<TabTransitionContextType>({
  setDirection: () => {},
  consumeDirection: () => null,
});

export function TabTransitionProvider({ children }: { children: React.ReactNode }) {
  const dirRef = useRef<Direction | null>(null);
  return (
    <TabTransitionContext.Provider
      value={{
        setDirection: (d) => { dirRef.current = d; },
        consumeDirection: () => {
          const d = dirRef.current;
          dirRef.current = null;
          return d;
        },
      }}
    >
      {children}
    </TabTransitionContext.Provider>
  );
}

export function useTabTransition() {
  return useContext(TabTransitionContext);
}
